import React from 'react';
import { connect } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

type StateProps = ReturnType<typeof mapState>;

export type Props = StateProps;

const TournamentMoneyAmount: React.FC<StateProps> = ({ totalTMoney = 0, totalTMoneyCurrency }) => (
  <>
    T<CurrencyAmount value={totalTMoney} currency={totalTMoneyCurrency} />
  </>
);

const mapState = (rootState: RootState) => ({
  totalTMoney: select.account.get(rootState).totalTMoney,
  totalTMoneyCurrency: select.account.get(rootState).totalTMoneyCurrency
});

export default connect(mapState)(TournamentMoneyAmount);
